import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ISharedVersionInfo } from '../../ts/models/ISharedVersionInfo';
import { GetShareActivityRequest, IGetShareActivityResult } from '../../ts/ServerApi/requests/GetShareActivityRequest';
import { ServerService } from '../../ts/services/ServerService';

class ShareActivityService {

  private getSharedVersionInfo = new WebClientListResourceFetcher(GetShareActivityRequest, ServerApiMapper.shareActivity);

  public getShareActivity(viewId: string): Promise<ISharedVersionInfo[]> {
    return toNativePromise(ServiceLocator.get<ServerService>('ServerService').sendRequest(new GetShareActivityRequest({
      viewId
    })).then((result: IGetShareActivityResult) => {
      return ServerApiMapper.shareActivity(result);
    }));
  }
}

export const ShareActivity = new ShareActivityService();
